window.addEventListener('SITE_START', () => {
  const $section = document.querySelector('#homeEsg');
  const lang = document.querySelector('html').getAttribute('lang');

  if (!$section) return;
  const bg = $section.querySelector('.__bg');
  const desc = $section.querySelector('.__desc');
  const bgImg = bg.querySelector('img');
  const getDiffX = () => {
    if (lang === 'en') return (window.innerWidth - desc.clientWidth * 0.9) / 2;
    return (window.innerWidth - desc.clientWidth) / 2;
  };
  const ROUND = 24;
  const df = getDiffX();

  gsap.set(bg, {
    clipPath: `inset(0 ${df}px 0 ${df}px round ${ROUND}px)`,
  });

  ScrollTrigger.create({
    trigger: $section,
    start: 'top bottom',
    end: 'bottom top',
    scrub: true,
    onUpdate: (self) => {
      const progress = self.progress;
      const posY = (1 - progress) * 100;
      gsap.set(bgImg, {
        objectPosition: `50% ${posY}%`,
        scale: 1 + progress * 0.325,
      });
    },
  });

  ScrollTrigger.create({
    trigger: $section,
    start: 'top bottom',
    end: 'top 20%',
    scrub: true,
    onUpdate: (self) => {
      const progress = self.progress;
      const diffX = getDiffX();
      let round = ROUND - progress * ROUND;
      let df = diffX - progress * diffX;

      if (lang === 'en') {
        const spaceX = (window.innerWidth - desc.clientWidth) / 2;
        df = spaceX + diffX - progress * diffX;
        round = 8 + (1 - progress) * (ROUND - 8); // ROUND(24) -> 8px
      }

      gsap.set(bg, {
        clipPath: `inset(0 ${df}px 0 ${df}px round ${round}px)`,
      });
    },
  });
});
